import { render, staticRenderFns } from "./withdrawsAndDeposits.vue?vue&type=template&id=577d78a3&"
import script from "./withdrawsAndDeposits.vue?vue&type=script&lang=js&"
export * from "./withdrawsAndDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports